import dayjs from 'dayjs';

import { COOKIES } from 'src/constants';

const getStorage = () => {
  const key = 'TEST_STORAGE';

  try {
    if (typeof localStorage === 'undefined') {
      return null;
    }

    localStorage.setItem(key, 'success');
    localStorage.removeItem(key);
    return localStorage;
  } catch (e) {
    console.log(e);
  }

  try {
    sessionStorage.setItem(key, 'success');
    sessionStorage.removeItem(key);
    return sessionStorage;
  } catch (e) {
    console.log(e);
  }

  return null;
};

const storage: null | Storage = getStorage();

const getStorageItem = (key: string) => {
  if (storage) {
    try {
      const value = storage.getItem(key);
      if (value) {
        try {
          return typeof JSON.parse(value) === 'object' && JSON.parse(value);
        } catch {
          return value;
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
};

const setStorageItem = (key: string, value: any) => {
  if (storage) {
    try {
      if (typeof value === 'object') {
        storage.setItem(key, JSON.stringify(value));
      } else {
        storage.setItem(key, value);
      }
    } catch (e) {
      console.log(e);
    }
  }
};

const removeStorageItem = (key: string) => {
  if (storage) {
    try {
      storage.removeItem(key);
    } catch (e) {
      console.log(e);
    }
  }
};

export const checkDisabledCookies = () => {
  return getStorageItem(COOKIES.COOKIES_FIELD) !== COOKIES.ENABLED ?? true;
};

export const rejectCookies = () => {
  setStorageItem(COOKIES.COOKIES_FIELD, COOKIES.DISABLED);
  setStorageItem(COOKIES.EXPIRES_FIELD, dayjs().add(1, 'month').toISOString());
};

export const acceptCookies = () => {
  setStorageItem(COOKIES.COOKIES_FIELD, COOKIES.ENABLED);
};

export const shouldDisplayPopupCookies = () => {
  const expires = getStorageItem(COOKIES.EXPIRES_FIELD);

  if (expires && dayjs().isAfter(expires, 'day')) {
    removeStorageItem(COOKIES.COOKIES_FIELD);
    removeStorageItem(COOKIES.EXPIRES_FIELD);
    return true;
  }

  return !getStorageItem(COOKIES.COOKIES_FIELD) ?? true;
};
